
export enum GlobalKeys {
    LoggedUserKey = "lenggiauit_loggedUserKey_accessToken",
    SiteSettingKey = "lenggiauit_SiteSettingKey",
    EncryptKey = "encryptKey",
    LanguageSelectedKey = "lenggiauit-lang",
    NoAvatarUrl = "/assets/images/Avatar.png", 
    NoTemplateImageUrl = "/assets/images/no_template_image.jpg",
    NoThumbnailUrl = "/assets/images/project_no_thumbnail.jpg",
    ProjectNoThumbnailUrl = "/assets/images/project_no_thumbnail.jpg"

}
export enum Locale {
    English = 'English',
    VietNam = 'Việt Nam'
}

export enum PermissionKeys { 
    Admin = "Admin",
    
}
 